import { AdditionalServiceSet } from '@sales/modules/subscription/models/additional-service-voice.model';

export class AdditionalServicesOffering {
  productId: string;
  parentOfferingId: string;
  additionalServices: AdditionalServiceSet;

  constructor(additionalServiceOffering: AdditionalServicesOffering) {
    const { productId, parentOfferingId, additionalServices } = additionalServiceOffering;

    this.productId = productId;
    this.parentOfferingId = parentOfferingId;
    this.additionalServices = additionalServices;
  }
}
